import { useTranslation } from 'react-i18next';

import { Button, Hint, Icon } from '@vestigas/ui';
import { InputLabel } from '~/ui/molecules/TanstackForm';

import { type BugReportForm } from '../utils';

type P = {
  readonly form: BugReportForm;
  readonly isSubmitting: boolean;
  readonly isVisible: boolean;
  readonly setIsVisible: (visible: boolean) => void;
};

export function VideoLinkSection({
  form,
  isSubmitting,
  isVisible,
  setIsVisible,
}: P) {
  const { t } = useTranslation('bugReport');

  return (
    <div className="flex flex-col gap-1">
      <InputLabel>
        <span className="inline-flex items-center gap-1">
          <Icon className="shrink-0" metaphor="videocam" size="sm" />
          {t(($) => $.dialog.videoLink.label)}
        </span>
      </InputLabel>
      {isVisible ? (
        <form.AppField name="videoLink">
          {(field) => (
            <div className="flex items-center gap-1">
              <field.TextField
                autoFocus
                className="flex-1"
                isDisabled={isSubmitting}
                placeholder={t(($) => $.dialog.videoLink.placeholder)}
                onBlur={() => {
                  field.handleBlur();
                  const currentValue = field.state.value as
                    | string
                    | null
                    | undefined;
                  if (!currentValue?.trim()) {
                    setIsVisible(false);
                  }
                }}
              />
              <Button
                aria-label={t(($) => $.dialog.cancelButton.text)}
                disabled={isSubmitting}
                icon={<Icon metaphor="close" />}
                onClick={() => {
                  field.handleChange('');
                  setIsVisible(false);
                }}
              />
            </div>
          )}
        </form.AppField>
      ) : (
        <>
          <Hint className="-mt-1.5 block">
            {t(($) => $.dialog.videoLink.hint)}
          </Hint>
          <Button
            buttonStyle="secondary"
            size="small"
            type="button"
            onClick={() => setIsVisible(true)}
          >
            {t(($) => $.dialog.videoLink.addLink)}
          </Button>
        </>
      )}
    </div>
  );
}
